module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'xpeqcsw0',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
